import { ConfiguredPermissions } from './configured-permissions';
import { AuthenticationInfo } from './authentication-info';

export class AuthorizationInfo {
  constructor(
    public permissions: ConfiguredPermissions,
    public authenticationInfo: AuthenticationInfo
  ) {}
}
